<template>
  <div id="app" v-show="appFlag">
    <!-- <tabar :tabar-data="tabar"></tabar> -->
    <router-view></router-view>
    <!-- <home></home> -->
  </div>
</template>


<script>
		function is_weixin() {
		    var ua = navigator.userAgent.toLowerCase();
		    if (ua.match(/MicroMessenger/i) == "micromessenger") {
		        return true;
		    } else {
		        return false;
		    }
		}
		
		function loadHtml(){
      var div = document.createElement('div');
			div.id = 'weixin-tip';
			div.innerHTML = '<p><img src="static/live_weixin.png" class="wximg" alt="微信打开"/></p>';
			document.body.appendChild(div);
		}
		
		function loadStyleText(cssText) {
	        var style = document.createElement('style');
	        style.rel = 'stylesheet';
	        style.type = 'text/css';
	        try {
	            style.appendChild(document.createTextNode(cssText));
	        } catch (e) {
	            style.styleSheet.cssText = cssText; //ie9以下
	        }
            var head=document.getElementsByTagName("head")[0]; //head标签之间加上style样式
            head.appendChild(style); 
	    }

import home from './components/Home';


export default {
  name: 'App',
  beforeCreate(){

  },
  created(){
    var isWeixin = is_weixin();
		var winHeight = typeof window.innerHeight != 'undefined' ? window.innerHeight : document.documentElement.clientHeight;
    var cssText = "#weixin-tip{position: fixed; left:0; top:0; background: rgba(0,0,0,0.8); filter:alpha(opacity=80); width: 100%; height:100%; z-index: 100;} #weixin-tip p{text-align: center; margin-top: 10%; padding:0 5%;}";
		if(isWeixin){
			loadHtml();
      loadStyleText(cssText);
      // this.appFlag = false;
    }
  },
  data () {
    return {
      appFlag:true
    }
  },
  mounted(){
  },
  components: { home },
}
</script>

<style>
  @import url("./css/reset.css");
	.wximg{max-width: 100%; height: auto;z-index: 120;}
	.test{height: 600px; max-width: 600px; font-size: 40px;}
  html,body,#app{
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100%;
  }
  #app{
    overflow-y: auto;
  }
 .mint-cell,.mint-cell-wrapper {
    background: none !important;
  }
.mint-checklist {
  display: inline-block;
  vertical-align: middle;
  margin-top: -12px;
  margin-right: -20px;
}
  
</style>



// WEBPACK FOOTER //
// src/App.vue